import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ProductConfigOpsType, ProductConfigStep, V6FrameConfigMode, V6FrameConfigType, V6FrameType, V6OptionValueType, V6ProductCreationStep, V6ProductType } from '../enums';
import {
  AttributeOption, BuildPakAttribute, FrameTemplate, IAttributeOption, IBuildPakAttribute,
  ICartItem,
  IFrameTemplate, IGetKwikkeyProductDetailsBody, IGetProductDependencies, IGetProductDependenciesBody, IGetProductDetailsBody, IMacro, IProductTemplate,
  IQuoteItem,
  IV6Product, ProductTemplate, V6Product, BaseResponse, Bp1configurationRequest, V6outerFrameBp1, V6NestedFrame, Product
} from '../models';
import { V6translationService, } from './v6translation.service';

import { ApiService } from './api.service';
import { ConfigService } from './config.service';
import { map, tap, catchError } from 'rxjs/operators';
import { Observable, Subject, empty } from 'rxjs';
import { cloneDeep, isNull, set } from 'lodash';
import { promise } from 'protractor';
import { V6macroService } from './v6macro.service';
import { State, process, orderBy } from "@progress/kendo-data-query";
import { OptionsStore } from '@progress/kendo-drawing';
import { masterFrameCodes } from '../../features/buildPak/admin/manage-product/create-configuration/moctData';
import { kkSetup } from '../../features/buildPak/admin/manage-product/create-configuration/kkSetupData';

@Injectable({
  providedIn: 'root'
})
export class V6productService {

  public productModel: ProductTemplate = new ProductTemplate();
  public previewModel: ProductTemplate = new ProductTemplate();
  public bp1PreviewModel: ProductTemplate = new ProductTemplate();
  public bp2PreviewModel: ProductTemplate = new ProductTemplate();
  public bp2PreviewModel_LastRun: ProductTemplate = new ProductTemplate();
  public bp3PreviewModel: ProductTemplate = new ProductTemplate();
  public summaryPreviewModel: ProductTemplate = new ProductTemplate();
  public v6ProductPreview: IV6Product = new V6Product();

  shouldUpdatePreview: Subject<boolean> = new Subject<boolean>();
  configFormIndex: number = 1;
  configFormStep: V6ProductCreationStep = V6ProductCreationStep.GENERAL_CONFIG;
  frameConfigMode: V6FrameConfigMode;
  nestedFrameIndexInEditMode: number;

  testConfigStep: number = 1;//1 add , 2 edit
  testPrdTempId: any = -1;

  constructor(
    private httpClient: HttpClient,
    private translationService: V6translationService,
    private macroService: V6macroService,
    //private attrService: V6attributeService,
  ) {
  }

  //#region API callls
  loadProductDetails(id: number, itemId: string, userView: boolean): Promise<IV6Product> {

    const body: IGetProductDetailsBody = {
      id: id,
      attributeIds: '13,103,180',
      macroIds: '1,2,3,,13',
      itemId: itemId,
      userView: userView

    }
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT.GET_PRODUCT_DETAILS}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => { let result: any; result = response.data; return result; }),
      tap((configuration) => { console.log(configuration); })
    ).toPromise();
  }
  loadKwikkeyProductDetails(productCode: string, itemId: string): Promise<IV6Product> {

    const body: IGetKwikkeyProductDetailsBody = {
      productCode: productCode,
      itemId: itemId
    }
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT.GET_KWIKKEY_PRODUCT_DETAILS}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => { let result: any; result = response.data; return result; }),
      tap((configuration) => { console.log(configuration); })
    ).toPromise();
  }
  loadProductDependencies(dependentAttributeIdList: string, dependentMacroIdList: string): Promise<IGetProductDependencies> {
    const body: IGetProductDependenciesBody = {
      attributeIds: dependentAttributeIdList,
      macroIds: dependentMacroIdList
    }
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT.GET_PRODUCT_DEPENDENCIES}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => { let result: any; result = response.data; return result; }),
      tap((configuration) => {
        //console.log(configuration);
      })
    ).toPromise();
  }
  getProduct
  //#endregion
  async initProduct(data) {
    //const p:ProductTemplate = await this.getProductDetails(data);
    //if (p.requiredMacroIds && p.requireAttributeIds) {
    //  //load macro and attributes
    //}
    //prepare the object then assign it to preview model
  }
  goToConfigForm(index: number) {
    console.log(index);
    this.configFormIndex = index;
    // this.frameEditingSteps = 0;//reste edit steps
  }

  createProduct() {
    this.testPrdTempId = -1;
    this.previewModel = new ProductTemplate();
    this.productModel = new ProductTemplate();
    this.bp1PreviewModel = new ProductTemplate();
  }
  editProduct(product: ProductTemplate, prdId: number) {
    this.testPrdTempId = prdId;
    //this.previewModel = cloneDeep(product);
    this.productModel = cloneDeep(product);
    this.previewModel = new ProductTemplate();
    this.bp1PreviewModel = new ProductTemplate();
  }

  editProductConfigInCart(item: ICartItem) {
    this.v6ProductPreview = new V6Product();
    this.v6ProductPreview.productId = item.configProductId;
    this.v6ProductPreview.productCode = item.configProductCode;
    this.currentConfigOPsType = ProductConfigOpsType.EDIT;
  }
  copyProductConfigInCart(item: ICartItem) {
    this.v6ProductPreview = new V6Product();
    this.v6ProductPreview.productId = item.configProductId;
    this.v6ProductPreview.productCode = item.configProductCode;
    this.currentConfigOPsType = ProductConfigOpsType.COPY;
  }
  editProductConfigInQuote(item: IQuoteItem) {
    this.v6ProductPreview = new V6Product();
    this.v6ProductPreview.productId = item.productId;
    this.v6ProductPreview.productCode = item.productCode;
    this.currentConfigOPsType = ProductConfigOpsType.EDIT;
  }
  copyProductConfigInQuote(item: IQuoteItem) {
    this.v6ProductPreview = new V6Product();
    this.v6ProductPreview.productId = item.productId;
    this.v6ProductPreview.productCode = item.productCode;
    this.currentConfigOPsType = ProductConfigOpsType.COPY;
  }


  getAllProductAttributesIds(prd: ProductTemplate): Array<any> {
    const attrIdList = [];
    prd.productAttributes.forEach((el, index) => {
      attrIdList.push(el.id);
    })
    prd.resourceFrame.attributeFilters.forEach((el, index) => {
      attrIdList.push(el.id);
    })
    prd.nestedFrames.forEach((frm, index) => {
      frm.attributeFilters.forEach((el) => {
        attrIdList.push(el.id);
      })
    });
    return attrIdList;
  }

  getAllMacroIds(prd: ProductTemplate): Array<any> {
    const macroIdList = [];
    if (prd.configNameExpression) {
      macroIdList.push(prd.configNameExpression.id);
    }
    prd.bp1Macros.forEach((el, index) => {
      macroIdList.push(el.id);
    })
    prd.bp2Macros.forEach((el, index) => {
      macroIdList.push(el.id);
    })
    //prd.confirmMacros.forEach((el, index) => {
    //  macroIdList.push(el.id);
    //})

    return macroIdList;
  }


  //#region helper fuctions
  translateProductAttributes(productAttributes: Array<IBuildPakAttribute>, translationFamily: string,) {
    productAttributes.forEach((el, i) => {
      const t = this.translationService.translatOptionToKD(translationFamily, el.v6ReferenceCode || el.name);
      if (t) {
        if (t === 'dummy do not show') {
          el.show = false;
        }
        else {
          el.publishedName = t;
        }
      }
    })
  }
  public switchBuildPakAttributes(productAttributes: Array<IBuildPakAttribute>, attrList: Array<IBuildPakAttribute>): IBuildPakAttribute[] {
    const v6Attributes: IBuildPakAttribute[] = [];
    productAttributes.forEach((item, index) => {
      const tempAttr = attrList.find(r => r.id === item.id);
      if (tempAttr) {
        tempAttr.show = true;//tempAttr.show === null ? true : tempAttr.show;
        tempAttr.isPublished = true;
        tempAttr.isReported = true;
        tempAttr.value = item.value;
        v6Attributes.push(tempAttr);
      }
    });
    return cloneDeep(v6Attributes);
  }
  public switchMacros(productMacros: Array<IMacro>, macros: Array<IMacro>): IMacro[] {
    const v6Macros: IMacro[] = [];
    productMacros.forEach((item, index) => {
      const temp = macros.find(r => r.id === item.id);
      if (temp) {
        v6Macros.push(temp);
      }
    });

    return cloneDeep(v6Macros);
  }
  public switchNameMacro(macroId: any, macros: Array<IMacro>) {
    const temp = macros.find(r => r.id === macroId);
    return temp;
  }

  //findResourceFrameAttr = function (product, attrName) {
  //  let attr = product.resourceFrame.attributeFilters.find(x => x.publishedName === attrName);
  //  if (!attr) {
  //    attr = {
  //      name: "", publishedName: '', type: "", show: false, value: '', options: [
  //      ]
  //    }
  //  }
  //  return attr

  //}
  //findProductAttr = function (product, attrName) {
  //  let attr = product.productAttributes.find(x => x.publishedName === attrName);
  //  if (!attr) {
  //    attr = {
  //      name: "", publishedName: '', type: "", show: false, value: '', options: [
  //      ]
  //    }
  //  }
  //  return attr
  //}
  //findNestedFrameAttr = function (product, attrName, frameIndex: number) {
  //  let attr = product.nestedFrames[frameIndex].attributeFilters.find(x => x.publishedName === attrName);
  //  if (!attr) {
  //    attr = {
  //      name: "", publishedName: '', type: "", show: false, value: '', options: [
  //      ]
  //    }
  //  }
  //  return attr
  //}
  //findAttrOption = function (optionName, attr: any) {
  //  const opt = attr.options.find(x => x.name === optionName);
  //  return opt;
  //}



  mapV6TypeToKDType(v6ValueType: string, valueType: string, value: string) {
    let kdType: string = '';
    switch (v6ValueType) {
      case 'List':
        kdType = 'list';
        break;
      case 'String':
        kdType = 'text';
        break;
      case 'Double':
        kdType = 'number';
        break;
      case 'Boolean':
        kdType = 'switch';
        break;
      case 'Flag':
        kdType = 'switch';
        break;
      case 'Formulae':
        if (valueType === 'String') {
          if (value.startsWith('"-----')) { kdType = 'sectionText'; }
          //else if () { }
          //else { kdType = 'none'; }
          else { kdType = 'text'; }
        }
        else {
          kdType = 'text';
        }
        break;
      default:
        kdType = 'text';
        break;
    }

    return kdType;
  }
  isSectionText(opt: any) {
    if (opt.v6ValueType === 'Formulae' && opt.valueType === 'String' && opt.value.startsWith('"-----')) {
      opt.isReported = true;
      opt.isPublished = true;
    }
  }
  mapV6OptionToAttribute(translationFamily: string, option: any, attribute: any, isNestedFrame: boolean, show: boolean) {
    attribute.v6ReferenceCode = option.key;
    attribute.name = option.key;
    const trn = this.translationService.translatOptionToKD(translationFamily, option.key);
    if (trn === 'dummy do not show') {
      attribute.publishedName = option.key;
      attribute.show = false;
    }
    else {
      attribute.publishedName = trn;
      attribute.show = show;
    }

    if (option.v6ValueType === 'Formulae') {
      //option.valueType = 'Formulae';
      const reg1 = /-/g;
      const reg2 = />/g;
      attribute.publishedName = attribute.publishedName.replace(reg1, '').replace(reg2, '');
    }
    attribute.value = option.value;
    attribute.v6ReferenceCode = option.key;
    attribute.isPublished = option.isPublished;
    attribute.type = this.mapV6TypeToKDType(option.v6ValueType, option.valueType, option.value);
    if (attribute.type === 'none') {
      attribute.isPublished = false;
      attribute.isReported = false;
    }

    switch (attribute.type) {
      case 'list':
        attribute.value = option.code;
        break;
      case 'switch':
        attribute.value = option.value.toUpperCase() === 'TRUE' ? true : false;
        break;
      default:
        attribute.value = option.value;
        break;
    }
    //attribute.value = attribute.type === 'list' ? option.code : option.value;// isNestedFrame ? option.listCode : option.value;
    let attrOptionList: IAttributeOption[] = [];
    let attrOption: IAttributeOption;
    switch (option.valueType) {
      case V6OptionValueType.LIST:
        option.listValues.forEach((el, index) => {
          attrOption = new AttributeOption();
          this.mapOptionValueToAttributeValue(translationFamily, option.key, el, attrOption);
          attrOptionList.push(attrOption);
        });

        break;
      case V6OptionValueType.STRING:
        attribute.value = option.value;
        break;
      case V6OptionValueType.DOUBLE:
        attribute.value = option.value;
        break;
      default: attribute.value = option.value; break;
    }
    attribute.options = attrOptionList;
  }
  mapAttributeToV6Option() {

  }
  mapOptionValueToAttributeValue(translationFamily, optionCode, optionValue, attributeValue) {
    const trn = this.translationService.translatOptionValueToKD(translationFamily, optionCode, optionValue.code, optionValue.description);
    if (trn === 'dummy do not show') {
      attributeValue.show = false;
    }
    attributeValue.description = trn;
    attributeValue.value = optionValue.code;

  }
  mapAttributeValueToOptionValue() { }


  mapCreateConfigRequestToProductModel(resp, model: IProductTemplate) {
    console.log('resp map start');
    model.status = resp.configuration.status;// "Created",
    model.dateCreated = resp.configuration.dateCreated;// "1899-12-30T00;//00;//00",
    model.originalItemId = resp.configuration.originalItemId;// null,
    model.v6QuoteNumber = resp.configuration.v6QuoteNumber;// "0",
    model.originalDescription = resp.configuration.originalDescription;// "190/350/500 Standard Entrance - Single or Pair 2 Door Openings",
    model.reference = resp.configuration.reference;// "ProdRef123",
    model.customerCode = resp.configuration.customerCode;// "3031",
    model.quoteItemCommonId = resp.configuration.quoteItemCommonId;// "3839f7f9-fe14-443b-b11e-ac6679e4a25c",
    model.quoteCommonId = resp.configuration.quoteCommonId;// "e7a0ef3c-d1f9-473e-9f6e-6bc0d8cfa5be",
    model.v6ItemSequenceNumber = resp.configuration.v6ItemSequenceNumber;// 0,
    model.unitNetSellPrice = resp.configuration.unitNetSellPrice;// null,
    model.unitGrossSellPrice = resp.configuration.unitGrossSellPrice;// null,
    model.quantity = resp.configuration.quantity;// 1.0,
    model.concessionedQuoteCopyCommonId = resp.configuration.concessionedQuoteCopyCommonId;// null,
    model.concessionedQuoteItemCopyCommonId = resp.configuration.concessionedQuoteItemCopyCommonId;// null
    //model.nestedFrames_quoteWideFrameId = resp.nestedFrames.quoteWideFrameId;
    let frame: IFrameTemplate;
    let attr: IBuildPakAttribute;
    // model.nestedFrames = [];
    resp.outerFrame.nestedFrames.forEach((el, index) => {//number of nest frame must match in rep and request
      if (!this.is2000T(model.productCode)
        && !this.isGlassvent(model.productCode)
        && !this.isAA3200(model.productCode)) {
        if (model.bypassBaseConfig && model.nestedFrames.length === index) {
          const f = new FrameTemplate();
          f.frameName = 'Door ' + (index + 1);
          model.nestedFrames.push(f);
        }
        else if ((model.type === V6ProductType.KWIK_KEY_DOOR || model.type === V6ProductType.KWIK_KEY_FRAME)
          && model.nestedFrames.length === index) {
          const f = new FrameTemplate();
          f.frameName = 'Door';
          model.nestedFrames.push(f);
        }
        frame = model.nestedFrames[index];// new FrameTemplate();
        if (!frame) { frame = new FrameTemplate(); frame.frameName = 'Door ' + (index + 1); model.nestedFrames.push(frame) }//testing line
        frame.quoteWideFrameId = el.quoteWideFrameId
        frame.attributeFilters = [];

        el.frameOptions.forEach((opt, optIndex) => {
          if (opt.key !== 'ID'
            && opt.valueType !== 'Empty'
            && !(!opt.isPublished && opt.isReported)
          ) {
            attr = new BuildPakAttribute();
            this.mapV6OptionToAttribute(model.translationFamily, opt, attr, true, opt.isPublished);
            frame.attributeFilters.push(attr);
          }
        });
        if (model.bypassBaseConfig && model.nestedFrames.length === index && frame.attributeFilters.length === 0) {
          model.nestedFrames[index]
        }
      }
    });
    //test remove if no atttribute in nested frame then remove it  

    for (let i = model.nestedFrames.length - 1; i >= 0; i--) {
      const validAttrs = model.nestedFrames[i].attributeFilters.filter(x => x.show);
      if (validAttrs.length === 0) {
        model.nestedFrames.splice(i, 1);
      }
    }


    model.resourceFrame.frameName = (this.is2000T(model.productCode) || this.isGlassvent(model.productCode) || this.isAA3200(model.productCode)) ? 'Options' : 'Frame';//testing line
    model.resourceFrame.quoteWideFrameId = resp.outerFrame.quoteWideFrameId
    model.resourceFrame.attributeFilters = [];
    resp.outerFrame.frameOptions.forEach((opt, index) => {
      if (opt.key !== 'ID'
        && opt.valueType !== 'Empty'
      ) {
        attr = new BuildPakAttribute();
        this.mapV6OptionToAttribute(model.translationFamily, opt, attr, false, opt.isPublished);
        model.resourceFrame.attributeFilters.push(attr);
      }
    });
    model.v6SummaryMessage = resp.messages;
    this.translateProductAttributes(model.productAttributes, model.translationFamily);
    console.log('resp map end');

    console.log(model);
  }


  mapUpdateConfigRequestToProductModel(resp, model: IProductTemplate) {
    console.log('resp map start');
    model.status = resp.configuration.status;// "Created",
    model.dateCreated = resp.configuration.dateCreated;// "1899-12-30T00;//00;//00",
    model.originalItemId = resp.configuration.originalItemId;// null,
    model.v6QuoteNumber = resp.configuration.v6QuoteNumber;// "0",
    model.originalDescription = resp.configuration.originalDescription;// "190/350/500 Standard Entrance - Single or Pair 2 Door Openings",
    model.reference = resp.configuration.reference;// "ProdRef123",
    model.customerCode = resp.configuration.customerCode;// "3031",
    model.quoteItemCommonId = resp.configuration.quoteItemCommonId;// "3839f7f9-fe14-443b-b11e-ac6679e4a25c",
    model.quoteCommonId = resp.configuration.quoteCommonId;// "e7a0ef3c-d1f9-473e-9f6e-6bc0d8cfa5be",
    model.v6ItemSequenceNumber = resp.configuration.v6ItemSequenceNumber;// 0,
    model.unitNetSellPrice = resp.configuration.unitNetSellPrice;// null,
    model.unitGrossSellPrice = resp.configuration.unitGrossSellPrice;// null,
    model.quantity = resp.configuration.quantity;// 1.0,
    model.concessionedQuoteCopyCommonId = resp.configuration.concessionedQuoteCopyCommonId;// null,
    model.concessionedQuoteItemCopyCommonId = resp.configuration.concessionedQuoteItemCopyCommonId;// null
    //model.nestedFrames_quoteWideFrameId = resp.nestedFrames.quoteWideFrameId;
    let frame: IFrameTemplate;
    let attr: IBuildPakAttribute;
    // model.nestedFrames = [];
    resp.outerFrame.nestedFrames.forEach((el, index) => {//number of nest frame must match in rep and request
      if (!this.is2000T(model.productCode)
        && !this.isGlassvent(model.productCode)
        && !this.isAA3200(model.productCode)) {
        if (model.bypassBaseConfig && model.nestedFrames.length === index) {
          const f = new FrameTemplate();
          f.frameName = 'Door ' + (index + 1);
          model.nestedFrames.push(f);
        }
        else if ((model.type === V6ProductType.KWIK_KEY_DOOR || model.type === V6ProductType.KWIK_KEY_FRAME)
          && model.nestedFrames.length === index) {
          const f = new FrameTemplate();
          f.frameName = 'Option ' + (index + 1);
          model.nestedFrames.push(f);
        }
        if (model.nestedFrames.length > 0) {
          frame = model.nestedFrames[index];// new FrameTemplate();     
          frame.quoteWideFrameId = el.quoteWideFrameId
          frame.attributeFilters = [];

          el.frameOptions.forEach((opt, optIndex) => {
            this.isSectionText(opt);
            if (opt.key !== 'ID'
              && opt.valueType !== 'Empty'
            ) {
              attr = new BuildPakAttribute();
              this.mapV6OptionToAttribute(model.translationFamily, opt, attr, true, opt.isReported);
              frame.attributeFilters.push(attr);
            }
          });
          if (model.bypassBaseConfig && model.nestedFrames.length === index && frame.attributeFilters.length === 0) {
            model.nestedFrames[index]
          }
        }
      }
    });
    //test remove if no atttribute in nested frame then remove it  

    for (let i = model.nestedFrames.length - 1; i >= 0; i--) {
      const validAttrs = model.nestedFrames[i].attributeFilters.filter(x => x.show);
      if (validAttrs.length === 0) {
        model.nestedFrames.splice(i, 1);
      }
    }



    model.resourceFrame.quoteWideFrameId = resp.outerFrame.quoteWideFrameId
    model.resourceFrame.attributeFilters = [];
    //"valueType": "Double", "v6ValueType": "Length"-- temp logic//!(opt.valueType === "Double" && opt.v6ValueType === "Length")
    resp.outerFrame.frameOptions.forEach((opt, index) => {
      if (opt.isReported
        && opt.key !== 'ID'
        && opt.valueType !== 'Empty'
      ) {
        attr = new BuildPakAttribute();
        this.mapV6OptionToAttribute(model.translationFamily, opt, attr, false, opt.isReported);
        model.resourceFrame.attributeFilters.push(attr);
      }
    });
    model.v6SummaryMessage = resp.messages;
    //model.fills = [];
    ////setup fills option
    //resp.fills.forEach((opt, optIndex) => {
    //  let fill = new V6Fill();
    //  this.mapV6OptionToAttribute(model.translationFamily, opt, attr, true, opt.isReported);
    //  model.fills.push(fill);
    //});
    this.translateProductAttributes(model.productAttributes, model.translationFamily);
    model.fills = resp.fills;
    console.log('resp map end');
    console.log(model);
  }
  lastResponse: any;
  curResponse: any;
  compareUpdateResponse(lasResp: any, curResp: any, translationFamily: string) {
    let diffResponse: any;
    if (!(lasResp && curResp)) return;
    //compare resource frame
    console.log('resource frame compare start');
    let curResourceAttrs = curResp.outerFrame.frameOptions.filter(x => x.isPublished);
    let lastResourceAttrs = lasResp.outerFrame.frameOptions.filter(x => x.isPublished);
    diffResponse = {
      isDifferent: false,
      outerFrame: {
        frameOptions: [],
        nestedFrames: []
      }
    };
    curResourceAttrs.forEach((curAttr, curI) => {
      let doesExist = lastResourceAttrs.find(x => x.key === curAttr.key && x.isPublished);
      if (!doesExist) {
        const t1 = this.translationService.translatOptionToKD(translationFamily, curAttr.key);
        if (t1 !== "dummy do not show") {
          diffResponse.outerFrame.frameOptions.push(curAttr);
          diffResponse.isDifferent = true;
        }
      }
    })
    console.log('resource frame compare end');
    //compare nested frames
    console.log('nested frame compare start');
    curResp.outerFrame.nestedFrames.forEach((curF, curIn) => {
      console.log('nested frame==>' + curIn);
      let diffNFrameAttrs = [];
      if (lasResp.outerFrame.nestedFrames.length > curIn) {
        let curPubFields = curF.frameOptions.filter(x => x.isPublished);
        let lastPubFields = lasResp.outerFrame.nestedFrames[curIn].frameOptions.filter(x => x.isPublished);
        if (curPubFields.length !== lastPubFields.length) {
          console.log('some fields go addded or removed');
        }
        curPubFields.forEach((curFld, curFldInded) => {
          let doesExist = lastPubFields.find(x => x.key === curFld.key && x.isPublished);
          if (!doesExist) {
            console.log('new field==>' + curFld.key);
            const t = this.translationService.translatOptionToKD(translationFamily, curFld.key);
            if (t !== "dummy do not show") {
              diffNFrameAttrs.push(curFld);
              diffResponse.isDifferent = true;
            }
          }
        });
      }
      if (diffNFrameAttrs.length > 0)
        diffResponse.outerFrame.nestedFrames.push(diffNFrameAttrs);
    })
    console.log('nested frame compare end');
    return diffResponse;
  }




  isGlassvent(productCode) {
    if (!productCode) return false;
    if (productCode.indexOf("GLASSvent") > -1) return true;
    return false;
  }
  is2000T(productCode) {
    if (!productCode) return false;
    if (productCode.indexOf("2000T") > -1) return true;
    return false;
  }
  isAA3200(productCode) {
    if (!productCode) return false;
    if (productCode.indexOf("AA3200M") > -1) return true;
    return false;
  }
  buildResourceFrameCode(rFrame: IFrameTemplate) {
    if (!rFrame) return;
    let code = '[' + (rFrame.framecodePrefix || '');
    rFrame.attributeFilters.forEach((el, index) => {
      if (el.name === 'Transom') {
        if (el.value === 'Transom') {
          code = code + 'TR';
        }
        else { }//do nothing }
      }
      else {
        code = code + (el.code || '');
      }
    })
    code = code + (rFrame.framecodeSuffix || '') + ']';
    rFrame.frameConfig = code;
  }
  buildNestedFrameCode(nFrame: IFrameTemplate) {
    if (!nFrame) return;
    //SVBMORT for door type product
    let code = '[' + (nFrame.framecodePrefix || '');
    if (nFrame.haveFrameCode) {
      code = code + (nFrame.frameCode || '');
    }
    else {
      switch (nFrame.frameConfigType) {
        case V6FrameConfigType.SBVMORT:
          let drT1 = nFrame.attributeFilters.find(x => x.v6ReferenceCode === 'DrType');
          if (drT1 && drT1.value) {
            let drOpt1 = drT1.options.find(x => x.value == drT1.value);
            if (drOpt1) {
              let drVal1 = drOpt1.description;
              if (drVal1.indexOf("Frame Only") > -1) {
                code = code + drOpt1.code;
                break;
              }
            }
          }

          nFrame.attributeFilters.forEach((el, index) => {
            //if (el.v6ReferenceCode !== 'DrType') {
            code = code + (el.code || '');
            //}
          });
          break;
        case V6FrameConfigType.OTHER:
          nFrame.attributeFilters.forEach((el, index) => {
            code = code + (el.code || '');
          })
          break;
        default:
          //SBVMORT
          let drT = nFrame.attributeFilters.find(x => x.v6ReferenceCode === 'DrType');
          if (drT && drT.value) {
            let drOpt = drT.options.find(x => x.value == drT.value);
            if (drOpt) {
              let drVal = drOpt.description;
              if (drVal.indexOf("Frame Only") > -1) {
                code = code + drOpt.code;
                break;
              }
            }
          }
          nFrame.attributeFilters.forEach((el, index) => {

            //if (el.v6ReferenceCode !== 'DrType') {
            code = code + (el.code || '');
            //}
          });
          break;
      }
    }
    code = code + ']';
    nFrame.frameConfig = code;
  }
  buildKwikKeyDoorFrameCode(frameSeries: string, frameCodePrefix: string, frameCode: string) {
    if (frameSeries.length > 0) {
      return "[" + frameCodePrefix + frameSeries + frameCode + "]";
    }
    else {
      return "[" + frameCodePrefix + frameSeries + frameCode + "]";//chnge it
    }
  }

  //#endregion
  //#region Screen Nav Helper
  currentProductConfigStep: ProductConfigStep = ProductConfigStep.BASE_CONFIG;
  goBack() {
    switch (this.currentProductConfigStep) {
      case ProductConfigStep.CONFIG_DETAILS:
        this.productModel = cloneDeep(this.bp1PreviewModel);
        this.currentProductConfigStep = ProductConfigStep.BASE_CONFIG;
        break;
      case ProductConfigStep.CONFIRM_CONFIG:
        this.productModel = cloneDeep(this.bp2PreviewModel);
        this.currentProductConfigStep = ProductConfigStep.CONFIG_DETAILS;
        break;
      default: break;
    }
  }
  currentConfigOPsType: ProductConfigOpsType = ProductConfigOpsType.ADD;
  //#endergion
  //#region API calls
  public getConfigurationX(quoteItemCommonId: any): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT.GET_CONFIGURATION}/${quoteItemCommonId}`;
    return ApiService.genericObservableGet(this.httpClient, endPoint).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  public copyConfigurationX(quoteItemCommonId: any): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT.COPY_CONFIGURATION}/${quoteItemCommonId}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, null).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  public createConfigurationX(body: any): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT.CREATE_CONFIGURATION}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );

  }
  public updateConfigurationServiceX(body: any): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT.UPDATE_CONFIGURATION}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }

  //k50-1037 Sanjeev start work
  public getKwikKeyConfiguration(productCode: any): Promise<any> {
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT.GET_KWIKKEYCONFIGURATION}/${productCode}`;
    return ApiService.genericObservableGet(this.httpClient, endPoint).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    ).toPromise();
  }
  //k50-1037 Sanjeev end work
  //#endregion
  //#region Reference
  organizeControlsInTabluarForm(sourceArray: any[], isBP3: boolean) {
    let finalArray: any[] = [];
    const chunkSize = 4;
    let iterationIndex = 0;
    let chunk: any[] = [];
    if (sourceArray.length <= chunkSize) {
      finalArray.push(sourceArray);
    }
    else {

      for (let i = 0; i < sourceArray.length; i++) {
        if (isBP3) {
          if (sourceArray[i].isReported) {
            if (iterationIndex > chunkSize) {
              iterationIndex = 0;
              finalArray.push(chunk);
              chunk = [];
            }
            chunk.push(sourceArray[i]);
            iterationIndex++;
          }
        }
        else {
          if (sourceArray[i].isPublished) {
            if (iterationIndex > chunkSize) {
              iterationIndex = 0;
              finalArray.push(chunk);
              chunk = [];
            }
            chunk.push(sourceArray[i]);
            iterationIndex++;
          }
        }
      }
      if (chunk.length > 0) {
        finalArray.push(chunk);
        chunk = [];
      }
    }
    //console.log(finalArray);
    return finalArray;
  }

  organizeControlsBySection(sourceArray: any[]) {

    let finalArray: any[] = [];
    let chunk;
    for (let i = 0; i < sourceArray.length; i++) {
      //if (sourceArray[i].isPublished) {
      if (sourceArray[i].type === 'sectionText') {
        if (chunk && chunk.length > 0) {
          finalArray.push(chunk);
        }
        chunk = [];
      }
      if (chunk) {
        chunk.push(sourceArray[i]);
      }
      //}

    }

    if (chunk && chunk.length > 0) {
      finalArray.push(chunk);
      chunk = [];
    }
    return finalArray;
  }
  organizeControlsInTabluarFormOnBP3(sourceArray: any[]) {
    let finalArray: any[] = [];
    const chunkSize = 4;
    let iterationIndex = 0;
    let chunk: any[] = [];
    if (sourceArray.length <= chunkSize) {
      finalArray.push(sourceArray);
    }
    else {

      for (let i = 0; i < sourceArray.length; i++) {
        //if (sourceArray[i].isReported) {
        if (iterationIndex > chunkSize) {
          iterationIndex = 0;
          finalArray.push(chunk);
          chunk = [];
        }
        chunk.push(sourceArray[i]);
        iterationIndex++;
        //}
      }
      if (chunk.length > 0) {
        finalArray.push(chunk);
        chunk = [];
      }
    }
    //console.log(finalArray);
    return finalArray;
  }
  organizeControlsBySectionOnBP3(sourceArray: any[]) {
    let finalArray: any[] = [];
    let chunk;
    const sections = sourceArray.filter(x => x.type === 'sectionText');
    if (sections.length == 0) {
      chunk = [];
      for (let i = 0; i < sourceArray.length; i++) {
        if (sourceArray[i].isReported) {
          chunk.push(sourceArray[i]);
        }
      }
      if (chunk && chunk.length > 0) {
        finalArray.push(chunk);
        chunk = [];
      }
    }
    else {
      for (let i = 0; i < sourceArray.length; i++) {
        //if (sourceArray[i].isPublished) {
        if (sourceArray[i].type === 'sectionText') {
          if (chunk && chunk.length > 0) {
            finalArray.push(chunk);
          }
          chunk = [];
        }
        if (chunk) {
          chunk.push(sourceArray[i]);
        }
        //}

      }

      if (chunk && chunk.length > 0) {
        finalArray.push(chunk);
        chunk = [];
      }
    }
    return finalArray;
  }

  tempGridState() {
    let productGridState: State = {
      skip: 0,
      take: 100,
      group: null,
      sort: [{
        field: 'productId',
        dir: 'desc'
      }],
      filter: {
        logic: 'and',
        filters: []
      },
    };
    return productGridState
  }
  hasError(resp) {
    let err: boolean = false;
    if (resp.messages && resp.messages.length > 0) {
      resp.messages.forEach((el, i) => {
        if (el.type && el.type === 2) { err = true; return; }
      });
    }
    return err;
  }

  isEmpty(el: IBuildPakAttribute) {
    switch (el.type) {
      case 'switch':
        return el.show && isNull(el.value);
      default:
        return el.show && !el.value
    }
  }
  //#endregion
  //#region KKconfig



  findMatchingKKFrameCode(prdCode, transomCode) {
    let fCode = prdCode;
    /*    
    it should be looking for a SCEMS frame​
    L and R would both select "S" for "Single" P would select "P" for "Pair"

    190LCEMS    To    450SCEMS

    190LCSMS    To    450SCEMS

    190PCSMS    To    450PCEMS

    190RCEMS    To    450SCEMS

    190RCSMS    To    450SCEMS

*/
    if (prdCode.indexOf('LCEMS') > -1) {
      prdCode = prdCode.replace('LCEMS', 'SCEMS');
    }
    else if (prdCode.indexOf('RCSMS') > -1) {
      prdCode = prdCode.replace('RCSMS', 'SCEMS');
    }
    else if (prdCode.indexOf('PCSMS') > -1) {
      prdCode = prdCode.replace('PCSMS', 'PCEMS');
    }
    else if (prdCode.indexOf('LCSMS') > -1) {
      prdCode = prdCode.replace('LCSMS', 'SCEMS');
    }
    else if (prdCode.indexOf('RCEMS') > -1) {
      prdCode = prdCode.replace('RCEMS', 'SCEMS');
    }



    let frCodes = masterFrameCodes.find(x => x.KKCode === (prdCode + transomCode));
    if (frCodes) { return frCodes.KKCode; }
  }
  findKKSetupDetails(productCode) {
    this.updateKKSetupDataForSCEMSProduct();
    let setupData = kkSetup.find(x => x.FullItemNumber === productCode);
    return setupData;
  }
  findMatchingKKDoorCode(prdCode, crossRailCode) {
    //prd code 190-LBHPNL36-14
    //found 190-LBHPNL%
    //search array and get 190LBHPNLN

    /*

    For SCEMS frame it would look for LCEMS door template
    example 190SCEMS will transform to 190LCEMS

    */

    if (prdCode.indexOf('SCEMS') > -1) {
      prdCode = prdCode.replace('SCEMS', 'LCEMS');
    }

    let doorCodes = masterFrameCodes.filter(x => x.KKCode.indexOf(prdCode) > -1);
    if (doorCodes.length === 0) { }//do something}
    else if (doorCodes.length === 1) {
      return doorCodes[0].KKCode;
    }
    else {
      if (crossRailCode) {
        let dC = doorCodes.find(x => x.KKCode === (prdCode + crossRailCode));
        if (dC) { return dC.KKCode; }
      }
      else {
        let dC = doorCodes.find(x => x.KKCode === prdCode);
        if (dC) { return dC.KKCode; }
      }
    }
  }
  getBasicKKConfig() {
    let basicRequest = new Bp1configurationRequest();
    basicRequest.defaultOptions = [];
    let defaultOptions = [];
    defaultOptions.push({ code: "Job/Exterior Finish", value: "[COL:K:40 (40)]" });
    defaultOptions.push({ code: "Hardware Finish", value: "[COL:K:40 (40)]" });
    defaultOptions.push({ code: "Interior Finish", value: "[COL:K:17 (17)]" });
    defaultOptions.push({ code: "Billing Finish", value: "[COL:K:17 (17)]" });
    defaultOptions.push({ code: "PushPull Finish", value: null });
    defaultOptions.push({ code: "1st Door Opening", value: "[FRA:A1:190RBHPNLN]" });

    basicRequest.defaultOptions = defaultOptions;
    basicRequest.outerFrame = new V6outerFrameBp1();
    basicRequest.outerFrame.frameCode = '';
    basicRequest.outerFrame.frameOptions.push({ code: 'Frame Type', value: '00' });
    let nestedFrame = new V6NestedFrame();
    nestedFrame.frameOptions = [];
    nestedFrame.frameCode = '';
    nestedFrame.frameOptions.push({ code: 'DrType', value: '01' });
    nestedFrame.frameOptions.push({ code: 'Hand', value: '01' });
    //nestedFrame.frameOptions.push({ code: 'Hinge', value: '01' });
    nestedFrame.frameOptions.push({ code: 'Lock', value: '34' });
    basicRequest.outerFrame.nestedFrames = [];
    basicRequest.outerFrame.nestedFrames.push(nestedFrame);
    return basicRequest;
  }
  setKKDefaultOptions(model: Bp1configurationRequest, hdFinVal, extFinVal, frameCode) {
    let extFinAttr = model.defaultOptions.find(x => x.code === 'Job/Exterior Finish');
    let hdFinAttr = model.defaultOptions.find(x => x.code === 'Hardware Finish');
    let doorOptionAttr = model.defaultOptions.find(x => x.code === '1st Door Opening');
    doorOptionAttr.value = frameCode;
    extFinAttr.value = extFinVal;
    hdFinAttr.value = hdFinVal;

    let intFin = model.defaultOptions.find(x => x.code === 'Interior Finish');
    let bilFin = model.defaultOptions.find(x => x.code === 'Billing Finish');
    intFin.value = extFinVal;
    bilFin.value = extFinVal;
  }
  setKKOuterFrameOptions(model: Bp1configurationRequest, frameTypeVal, frameCode) {
    model.outerFrame.frameOptions = [{ code: 'Frame Type', value: frameTypeVal }];
    model.outerFrame.frameCode = frameCode;
  }

  setKKNestedFrame(model: Bp1configurationRequest, setupDetails, nestedFrameCode, frameonly = false) {
    let setupData = setupDetails;
    if (!setupData) return model;
    let nestedFrame = new V6NestedFrame();
    nestedFrame.frameOptions = [];
    nestedFrame.frameCode = nestedFrameCode;
    nestedFrame.frameOptions.push({ code: 'DrType', value: this.tempPadZeroIfNeeded(setupData.DrType).toString() });
    nestedFrame.frameOptions.push({ code: 'Hand', value: this.tempPadZeroIfNeeded(setupData.Hand).toString() });
    //k50-1037 Sanjeev start work
    if (frameonly) {
      nestedFrame.frameOptions.push({ code: 'Hinge', value: this.tempPadZeroIfNeeded(setupData.Hinge).toString() });
    }
    //k50-1037 Sanjeev end work
    nestedFrame.frameOptions.push({ code: 'Lock', value: this.tempPadZeroIfNeeded(setupData.Lock).toString() });
    model.outerFrame.nestedFrames = [];
    model.outerFrame.nestedFrames.push(nestedFrame);
  }

  tempPadZeroIfNeeded(value) {
    //k50-1037 Sanjeev start work - add a additional check for int value check
    if (!isNaN(value)) {
      //k50-1037 Sanjeev end work
      const val = parseInt(value);
      if (val && val > -1 && val < 10) {
        return '0' + val.toString();
      }
      else { return value || ''; }
    } else {
      return value
    }
  }

  updateKKSetupDataForSCEMSProduct() {
    //This is a hack, note that this will update KKSetup data objcet.
    //Later when we move the data to table this needs to be deleted
    try {
      kkSetup.forEach((item) => {
        if (item.FullItemNumber.indexOf("SCEMS") > -1) {
          item.Hand = 5;
        }
      });
    }
    catch (e) { }
  }
  //#endregion

  //#region 2000T related additional logic

  modifyProductModelFor2000T(model: IProductTemplate) {

    //if (this.is2000T(model.productCode)) {
    //   //make Std Hinges readonly
    //  const stdHinge = model.resourceFrame.attributeFilters.find(x => x.name === 'Std Hinges');
    //  if (stdHinge) {stdHinge.type=}
    //}
  }

  //#endregion

  //#region Product Comaprision
  compareModels(model1: ProductTemplate, model2: ProductTemplate) {
    console.log('product comparision start');
    const resoureFrameAttrs2 = model2.resourceFrame.attributeFilters.filter(x => x.isPublished);
    const resoureFrameAttrs1 = model1.resourceFrame.attributeFilters.filter(x => x.isPublished);
    resoureFrameAttrs2.forEach((el, i) => {
      const t = resoureFrameAttrs1.find(x => x.publishedName === el.publishedName);
      if (!t) { console.log(el.publishedName); }
    });
    model2.nestedFrames.forEach((nf, i) => {
      let nfAttrs2 = nf.attributeFilters.filter(x => x.isPublished);
      let nfAttrs1 = model1.nestedFrames[i].attributeFilters.filter(x => x.isPublished);//index should be there
      nfAttrs2.forEach((el, i) => {
        const t = nfAttrs1.find(x => x.publishedName === el.publishedName);
        if (!t) { console.log(el.publishedName); }
      });
    });
    console.log('product comparision end');
  }
  //#endregion

  //#region PP Fin related mods
  repositionPPFinIfApplicable(destination: ProductTemplate) {
    const pushPullFin1 = destination.productAttributes.find(x => x.v6ReferenceCode === 'PushPull Finish');
    if (pushPullFin1) {
      pushPullFin1.show = false;
      destination.nestedFrames.forEach((nfr, i) => {
        let pushPullFin = cloneDeep(pushPullFin1);
        const PncPull = nfr.attributeFilters.find(x => x.v6ReferenceCode === "PncPull");
        const indexpushPullFin = nfr.attributeFilters.findIndex(r => r.v6ReferenceCode === 'PushPull Finish');
        if (indexpushPullFin > -1) {
          return;
        }
        if (PncPull) {
          const PncPullIndex = nfr.attributeFilters.findIndex(r => r.publishedName === PncPull.publishedName);
          nfr.attributeFilters.splice((PncPullIndex + 1), 0, pushPullFin);
        } else {
          const PPullSet = nfr.attributeFilters.find(x => x.v6ReferenceCode === "PPullSet");
          if (PPullSet) {
            const PPullSetIndex = nfr.attributeFilters.findIndex(r => r.publishedName === PPullSet.publishedName);
            nfr.attributeFilters.splice((PPullSetIndex + 1), 0, pushPullFin);
          }
        }
      })
    }
  }
  //#endregion

  //#region BUBBLE TEXT
  //#endregion

  isInAdminSection: boolean = false;
}
